import React, { Component } from 'react';

import { LowerLimitRules } from './generic/LowerLimitRules';

export class DistanceFareRules extends Component {
    constructor(props) {
        super(props);

        this.state = {
            model: this.props.model,
        };
    }

    // ----------------------

    render() {
        const { model } = this.state;

        if (null === model || undefined === model) {
            return null;
        }

        const { isEditable } = this.props;

        if (Array.isArray(model.rules)) {
            model.rules.sort((a, b) => a.lowerLimit - b.lowerLimit);
        }

        return (
            <LowerLimitRules
                model={model}
                isEditable={isEditable}
                description="Distância"
                unit="km"
                minValue={0}
                onSave={(a) => this.props.onSave(a)}
                onExit={() => this.props.onExit()} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/fareProducts/rules/DistanceFareRules.js